import { useSelector } from 'react-redux';

export const useTranslate = () => {
  const labels = useSelector(state => state.home.common_data?.lang_labels);
  return (key) => {
    if (!labels) return key;
    return labels[key] || key;
  };
};